// Render Prop

import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { observer } from 'mobx-react';

import ChangeAccountPanel from './widgets/ChangeAccountPanel';
import PayPeriodSelection from './widgets/PayPeriodSelection';

import AccountInfoWidget from '../widgets/AccountInfo';

import queryString from "query-string";

import ConfirmAward from "./ConfirmAward";
import { TimesheetApi } from '../../util/api/TimesheetApi';
import { Alert } from '../../store/Alert';



export class SelectPayPeriod extends Component {
    static displayName = SelectPayPeriod.name;
    

    constructor(props) {
        super(props);

        let account = props.store.accounts.getById(this.props.match.params.id);

        this.state = {
            selectedPayPeriod: false,
            account: account
        };

        this.selectForm = this.selectForm.bind(this);
        this.displayAccountWidget = this.displayAccountWidget.bind(this);
        this.selectPayPeriod = this.selectPayPeriod.bind(this);
        this.returnToAccount = this.returnToAccount.bind(this);
        this.displayAccountStatus = this.displayAccountStatus.bind(this);
        
        account = account.include(["employer"])
        props.store.updateBanner(`Manage timesheets`, account.employer.name)

        this.deleteTimesheetDraft = this.deleteTimesheetDraft.bind(this);

        this.keyCount = 0;
        this.getKey = this.getKey.bind(this);
    }


    async deleteTimesheetDraft(e) {
        if(window.confirm( "Are you sure you'd like to delete this draft? All info will be lost." )) {
            const timesheetId = e.target.value;
            console.log(e)
            try {

                await TimesheetApi.delete(timesheetId);
                
                await this.props.store.getFromApi([ "timesheets","timestamps","accounts"])
                
                let successAlert = new Alert("Successfully deleted draft!");
            }
            catch (e) {
                let errorAlert = new Alert("Error deleting draft", "There was an error deleting this timesheet draft. Please refresh the page and retry. If the problem persists, please contact the site admin at: tuf97238@temple.edu.");
            }
        }
    }

    //When the user wants to return from to this page from the Timesheet form.
    returnToAccount() {
        this.setState({selectedPayPeriod: false });
    }

    render() {
        let account = this.props.store.accounts.getById(this.props.match.params.id);

        if (account.hasAcceptedAwardOffer) {
            return (
                <div role="main">
                    <div className="row">
                        <div role="aside" className="col-md-4">
                            {this.displayAccountWidget()}
                        </div>
                        <div className="col-md-8">
                            {this.displayAccountStatus()}
                            {this.selectForm()}
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <ConfirmAward 
                    store={this.props.store}
                    accountId={this.props.match.params.id}
                />
            )
        }
    }

    displayAccountStatus() {
        if (this.state.account.accountStatusChanges.length > 0) {
            let accountStatus = this.state.account.accountStatusChanges[this.state.account.accountStatusChanges.length -1]
            console.log(accountStatus)
            if (accountStatus.status == "Locked") {
                return (
                    <div className="alert-danger p-2 mb-3">
                        <p className="mb-1">Account Status:</p>
                        <h2 className="h3"><b>{accountStatus.status}</b></h2>
                        {accountStatus.note && (<p className="mb-2"><b>Note from adminstrator:</b> {accountStatus.note}</p>)}
                    </div>
                )
            }
        }
        return (undefined)
    }



    selectPayPeriod(event) {
        const submission = {
            endDay : event.target.value,
            accountId : this.props.match.params.id
        }

        this.props.history.push("/submission?" + queryString.stringify(submission));
    }

    getKey(){
        return this.keyCount++;
    }

    selectForm() {
        return (
            <div>
                <label id="unsubmitted-timesheet-label" className="h2">Unsubmitted Timesheets</label>
                <div role="list" aria-labelledby="unsubmitted-timesheet-label">
                    {/*< PayPeriodSelection accountId={this.props.match.params.id} store={this.props.store}/> */}
                    {/*payPeriods["unsubmitted"].map(timeslot => */}
                    <PayPeriodSelection 
                        key={this.getKey()}
                        deleteTimesheetDraft={this.deleteTimesheetDraft}
                        accountId={this.props.match.params.id} 
                        store={this.props.store} 
                        type="unsubmitted" 
                        selectPayPeriod={this.selectPayPeriod} />
                </div>
                <label id="awaiting-signature-label" className="h2">Awaiting Signature</label>
                <div role="list" aria-labelledby="awaiting-signature-label">
                    <PayPeriodSelection 
                        key={this.getKey()}
                        accountId={this.props.match.params.id} 
                        store={this.props.store} 
                        type="pending" 
                        selectPayPeriod={this.selectPayPeriod} />
                </div>
                <div role="list">
                    <h2>Processed Timesheets</h2>
                    <PayPeriodSelection 
                        key={this.getKey()}
                        accountId={this.props.match.params.id} 
                        store={this.props.store} 
                        type="completed" 
                        selectPayPeriod={this.selectPayPeriod} />
                </div>
            </div>
        )
    }

    displayAccountWidget() {
        return (
            <React.Fragment>
                <AccountInfoWidget accountId={this.state.account.id} store={this.props.store} />
                <br></br>
                <ChangeAccountPanel store={this.props.store} history={this.props.history} />
            </React.Fragment>
        ); 
    }
}

export default withRouter(observer(SelectPayPeriod));